import { View } from "@react-pdf/renderer";
import PdfLabel from "../typography/PdfLabel";
import PdfValue from "../typography/PdfValue";
import { useMemo } from "react";

const PdfDataItemRowCentered = ({
  label,
  value,
  type,
  style,
  valueStyle,
  labelStyle,
}) => {
  const styles = useMemo(() => {
    return {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      gap: "4px",
      marginTop: 12,
      ...style,
    };
  }, [style]);
  return (
    <View style={styles}>
      <PdfLabel style={labelStyle}>{label}</PdfLabel>
      <PdfValue type={type} style={valueStyle}>
        {value}
      </PdfValue>
    </View>
  );
};

export default PdfDataItemRowCentered;
